import React from "react";
import {useTranslation} from "react-i18next";
import {Grid, ListItem, ListItemIcon, ListItemText, Paper, Tooltip, Typography} from "@material-ui/core";
import List from "@material-ui/core/List";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import Loader from "../core/Loader";
import withWidth, {WithWidthProps} from "@material-ui/core/withWidth";
import {ExternalPublicTrackingDTO} from "../../constants/ParcelContants";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
        },
        grid: {
            "& .MuiGrid-item": {
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column"
            }
        },
        lineItemContextContainer: {
            display: "flex",
            flex: 1,
            justifyContent: "space-between",
            alignItems: "center"
        },
        shipmentInfoContainer: {
            display: "flex",
            alignItems: "center",
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        shipmentInfoCard: {
            flex: 1
        },
        caption: {
            fontWeight: "bold",
            marginRight: 5
        },
        value: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: '11rem'
        },
        modality: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingRight: 20,
            "& img": {
                height: 40
            }
        },
    }),
);


interface IParcelInfoCard {
    parcel?: ExternalPublicTrackingDTO
}


const ParcelTrackingInfoCard: React.FC<IParcelInfoCard & WithWidthProps> = ({
                                                                                parcel,
                                                                                width
                                                                            }) => {
    const classes = useStyles();


    return <Paper className={classes.root}>
        <List>
            <ListItem>
                <ListItemIcon>
                    <div className={classes.modality}>
                        <img src={`/assets/icons/parcel.png`}
                             alt="parcel"/>
                    </div>
                </ListItemIcon>
                <ListItemText
                    primary={<CardItem parcel={parcel} width={width}/>}
                />
            </ListItem>

        </List>
    </Paper>
};


const CardItem: React.FC<IParcelInfoCard & WithWidthProps> = ({parcel, width}) => {

    const {t} = useTranslation();

    if (!parcel) {
        return <Loader/>;
    }


    return <React.Fragment>
        <Grid container justifyContent="center"
              alignItems="center">

            <Grid item xs={12} sm={6}>
                <InfoCardLine property={t("parcel.info.delivery-date")}
                              value={parcel.expectedDeliveryDate?.replace("T", " ").slice(0, -3)}
                              width={width}/>
                <InfoCardLine property={t("shipment.reference")}
                              value={parcel.references?.map(rf => rf.reference).join(", ")}
                              width={width}/>
            </Grid>

            <Grid item xs={12} sm={6}>
                <InfoCardLine property={t("parcel.info.shipper-country")} value={parcel.from?.country} width={width}/>
                <InfoCardLine property={t("parcel.info.consignee-country")} value={parcel.to?.country} width={width}/>
            </Grid>


        </Grid>

    </React.Fragment>
};

export const InfoCardLine: React.FC<{ property?: string, value?: string } & WithWidthProps> = ({
                                                                                                                                                                                                           property,
                                                                                                                                                                                                           value,
                                                                                                                                                                                                           width
                                                                                                                                                                                                       }) => {

    const classes = useStyles();


    return <div className={classes.shipmentInfoContainer}
                style={{width: width === "xs" ? '12rem' : '25rem'}}
    >
        {property && <Typography
            variant="body1"
            color="textPrimary"
            className={classes.caption}
        >
            {property}:
        </Typography>}
        {value && <Tooltip title={value}>
            <Typography
                noWrap={true}
                variant="body2"
                color="textPrimary"
            >
                {value}
            </Typography>
        </Tooltip>}
    </div>
};


export default withWidth()(ParcelTrackingInfoCard);
